import * as types from "../ActionType";

const initState = {
    roles: [],
    loadingRoles: true,
    permissions: [],
    loadingpermissions: true,
    mainPermission: [],
    loadingMainPermission: true
}

const RolesAndPermissionsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_ROLE:
            return { ...state, loadingRoles: true }
        case types.GET_ROLES:
            return { ...state, roles: action.payload, loadingRoles: false }
        case types.GET_PERMISSIONS_BY_ROLE:
            return { ...state, permissions: action.payload, loadingpermissions: false }
        case types.EMPTY_PERMISSIONS_BY_ROLE:
            return { ...state, permissions: action.payload, loadingpermissions: true }
        case types.GET_MAIN_PERMISSIONS:
            return { ...state, mainPermission: action.payload, loadingMainPermission: false }
        case types.EDIT_PERMISSIONS:
            return { ...state }
        default:
            return state;
    }
};

export default RolesAndPermissionsReducer;
